var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.739 20.7836C21.2522 20.2739 22.0748 20.2739 22.5879 20.7836L25.9587 23.5044C25.9723 23.5154 25.9892 23.5214 26.0067 23.5214C26.0271 23.5214 26.0468 23.5296 26.0609 23.5443C26.7247 24.2395 26.7172 25.347 26.0386 26.033C25.3524 26.7266 24.2398 26.7266 23.5536 26.033L20.739 22.8072L20.6322 22.6866C20.4332 22.4348 20.3233 22.1208 20.3233 21.7954C20.3233 21.4157 20.4729 21.0516 20.739 20.7836ZM11.3882 0C14.4085 0 17.3051 1.21273 19.4408 3.37141C21.5765 5.53009 22.7764 8.45788 22.7764 11.5107C22.7764 17.8679 17.6777 23.0214 11.3882 23.0214C5.09866 23.0214 0 17.8679 0 11.5107C0 5.15352 5.09866 0 11.3882 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8832 21.4931L21.9198 21.5293L21.9598 21.5617L25.3306 24.2825L25.3306 24.2826C25.3629 24.3087 25.3966 24.3327 25.4314 24.3548C25.6231 24.6569 25.5884 25.0661 25.3277 25.3297C25.0387 25.6218 24.5781 25.6276 24.2823 25.3472L21.4925 22.1497L21.4925 22.1497L21.4874 22.1439L21.4048 22.0508C21.3527 21.9781 21.3233 21.8888 21.3233 21.7954C21.3233 21.6793 21.3686 21.5701 21.4461 21.4907C21.5694 21.3707 21.7608 21.3715 21.8832 21.4931ZM11.3882 1C14.1398 1 16.781 2.10475 18.73 4.07472C20.6793 6.04506 21.7764 8.71966 21.7764 11.5107C21.7764 17.3257 17.1154 22.0214 11.3882 22.0214C5.66101 22.0214 1 17.3257 1 11.5107C1 5.69569 5.66101 1 11.3882 1Z",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.0eac993221eaf8f5fb2cb1387031f03c.svg";
export { ForwardRef as ReactComponent };